import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/p/$projectId/$branch/explorer/files/$")({
  component: () => null,
});
